import { render } from "./FoodSlider.vue?vue&type=template&id=5ebee4a1&ts=true"
import script from "./FoodSlider.vue?vue&type=script&lang=ts"
export * from "./FoodSlider.vue?vue&type=script&lang=ts"

import "./FoodSlider.vue?vue&type=style&index=0&id=5ebee4a1&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__